export async function fetchInventory(vendorId: string) {
  const response = await fetch(`/api/inventory?vendor_id=${vendorId}`);
  if (!response.ok) throw new Error('Failed to fetch inventory');
  const json = (await response.json()) as { inventory: [InventoryItem, InventoryItem] };
  return json.inventory;
}

let buttonListener: EventListenerOrEventListenerObject | undefined = undefined;
export function updateVippsButton(item: InventoryItem) {
  const vippsButton = document.querySelector('vipps-mobilepay-button');
  if (!vippsButton) {
    console.log('No vipps button found on page. Aborting vipps button update...');
    return;
  }

  buttonListener && vippsButton.removeEventListener('click', buttonListener);
  buttonListener = async () => {
    const textarea = document.querySelector('textarea') as HTMLTextAreaElement;
    const response = await fetch('/api/coupon', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ itemId: item.id, message: textarea.value }),
    });

    const data = await response.json();
    if (data.payment.redirectUrl) {
      window.location.href = data.payment.redirectUrl;
    } else {
      alert('Could not start Vipps session.');
    }
  };
  vippsButton.addEventListener('click', buttonListener);
}
